import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/7dda6cd5-9ca9-470b-9357-4b1792f160e7/images/fc0785e7003fe4b44b46eedd0cf5c9d8a2af7e76756c384e939aeb7ded327e03.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="hero-overlay absolute inset-0"></div>
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <span className="hero-animate inline-block bg-[#F2CC8F]/20 text-[#F2CC8F] px-4 py-2 rounded-full text-sm font-medium mb-6">
          {t("home.hero.badge")}
        </span>
        <h1 className="hero-animate hero-animate-d1 text-5xl md:text-7xl font-bold text-white mb-6 font-['Playfair_Display'] leading-tight hero-text-shadow">
          {t("home.hero.title")} <span className="text-[#F2CC8F]">{t("home.hero.titleHighlight")}</span>
        </h1>
        <p className="hero-animate hero-animate-d2 text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          {t("home.hero.subtitle")}
        </p>
        <div className="hero-animate hero-animate-d3 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/booking">
            <Button
              data-testid="hero-book-btn"
              className="btn-primary text-lg px-10 py-6 btn-hover-pulse"
            >
              {t("home.hero.bookBtn")}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
          <Link to="/menu">
            <Button
              data-testid="hero-menu-btn"
              variant="outline"
              className="bg-white/10 backdrop-blur border-white/30 text-white hover:bg-white/20 text-lg px-10 py-6 rounded-full transition-all duration-300 hover:scale-[1.03]"
            >
              {t("home.hero.menuBtn")}
            </Button>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
